import { SET_SCANS_SORT } from '../actions';

export default function setScansSort(field, dir) {
  return {
    type: SET_SCANS_SORT,
    field,
    dir,
  };
}
